export default __webpack_public_path__ + "static/media/dribbble.c4dc0fbd.svg";